import React from "react"

const SideCheckBox = ({ onClick, isAdded }) => (
    <div className="side-button" onClick={onClick}>
        <span className={`icon icon-${isAdded ? "checked" : "unchecked"}`} />
    </div>
)

export default SideCheckBox
